import { defaultBillingAccountId, preClearBillingAccountId } from "@/mock-api/data/billingAccountIds.ts";
import type { Bucket, StorageAccount } from "@warrenio/api-spec/spec.oats.gen";

const user_id = 29;

export const defaultStorageId = "storage-with-data";
export const defaultStorageAccountUuid = "11111111-2222-3333-4444-555555555555";
export const suspendedStorageAccountUuid = "11111111-1111-2222-3333-555555555555";

export const storageAccounts: StorageAccount[] = [
    {
        user_id,
        is_suspended: false,
        billing_account_id: defaultBillingAccountId,
        uuid: defaultStorageAccountUuid,
        title: "Default storage account",
        is_deleted: false,
    },
    {
        user_id,
        is_suspended: true,
        billing_account_id: defaultBillingAccountId,
        uuid: suspendedStorageAccountUuid,
        title: "Suspended account",
        is_deleted: false,
        created_at: "2026-07-15T08:20:38.070+0000",
    },
];

export const storageList: Bucket[] = [
    {
        storage_account_uuid: defaultStorageAccountUuid,
        name: "storage-empty",
        size_bytes: 0,
        billing_account_id: defaultBillingAccountId,
        billing_account_id_override: preClearBillingAccountId,
        num_objects: 0,
        created_at: "2023-12-15T15:31:02.377+0000",
        modified_at: "2024-01-23T10:23:50.380+0000",
    },
    {
        storage_account_uuid: suspendedStorageAccountUuid,
        name: "suspended",
        size_bytes: 2842063,
        billing_account_id: defaultBillingAccountId,
        num_objects: 1,
        created_at: "2022-02-10T13:50:14.149+0000",
        modified_at: "2024-01-24T12:05:59.643+0000",
    },
    {
        storage_account_uuid: defaultStorageAccountUuid,
        name: defaultStorageId,
        size_bytes: 63612865,
        billing_account_id: defaultBillingAccountId,
        num_objects: 18,
        created_at: "2022-03-04T09:58:29.294+0000",
        modified_at: "2024-01-26T15:26:16.426+0000",
    },
];
